module.exports = __webpack_public_path__ + "img/m_role_1_name.482bff05.png";